module.exports = __webpack_public_path__ + "img/VM-logo.d90cb505.svg";